export default __webpack_public_path__ + "static/media/CTP_Light_DE.76a36238.svg";